'use client';

import { createInstance, Resource } from 'i18next';
import { PropsWithChildren, Suspense } from 'react';
import { I18nextProvider } from 'react-i18next';

import { Preloader } from './Preloader/Preloader';
import { DEFAULT_NS } from '@/modules/localization';
import { initTranslations } from '@/modules/localization/utils/i18n';

interface TranslationsProviderProps {
  locale: string;
  defaultNS?: string;
  namespaces?: string[];
  resources?: Resource;
}

export default function TranslationsProvider({
  namespaces,
  resources,
  children,
  locale,
}: PropsWithChildren<TranslationsProviderProps>) {
  const instance = createInstance();
  initTranslations(locale, namespaces, instance, resources);

  return (
    <Suspense fallback={<Preloader />}>
      <I18nextProvider i18n={instance} defaultNS={DEFAULT_NS}>
        {children}
      </I18nextProvider>
    </Suspense>
  );
}
